import { Grid, Typography } from '@material-ui/core';
import InputText from 'components/InputText';
import Context from 'context';
import React, { useContext } from 'react';
import { Colors } from 'type';
import { HeaderWrapper, PictureWrapper } from './MainInfo.style';

const MainInfo = () => {
  const {
    mainText,
    suppText,
    caption,
    setMainText,
    setSuppText,
    setCaption,
    gender,
    profile,
    colors,
  } = useContext(Context);
  return (
    <Grid
      container
      spacing={1}
      alignItems='flex-end'
      justify='space-between'
      style={{ padding: '2em 2em' }}
    >
      <Grid
        container
        item
        xs={6}
        direction='column'
        alignItems='center'
        spacing={1}
        style={{ maxWidth: 'none' }}
      >
        <Grid item style={{ flexGrow: 1 }}>
          <HeaderWrapper
            color={colors[Colors.Secondary]}
            backgroundColor={colors[Colors.Primary]}
            width='463px'
          >
            <Typography
              variant='h3'
              style={{
                fontFamily: 'Roboto, san-serif',
                fontWeight: 'bold',
                fontSize: '64px',
              }}
            >
              Timeline
            </Typography>
          </HeaderWrapper>
        </Grid>
        <Grid item style={{ flexGrow: 1 }}>
          <HeaderWrapper
            color={colors[Colors.Primary]}
            backgroundColor={colors[Colors.Secondary]}
            width='463px'
          >
            <InputText
              fontSize='36px'
              textAlign='center'
              value={mainText}
              color={colors[Colors.Primary]}
              onChange={(e) => setMainText(e.target.value)}
            />
            <InputText
              fontSize='20px'
              textAlign='center'
              value={suppText}
              color={colors[Colors.Primary]}
              onChange={(e) => setSuppText(e.target.value)}
            />
          </HeaderWrapper>
        </Grid>
      </Grid>

      <Grid
        container
        item
        xs={4}
        direction='column'
        alignItems='center'
        spacing={1}
      >
        <Grid item>
          <PictureWrapper
            gender={gender}
            url={profile}
            borderColor={colors[Colors.Secondary]}
          ></PictureWrapper>
        </Grid>
        <Grid item>
          <HeaderWrapper
            color={colors[Colors.Primary]}
            backgroundColor={colors[Colors.Tertiary]}
            width='211px'
          >
            <InputText
              fontSize='28px'
              textAlign='center'
              value={caption}
              color={colors[Colors.Primary]}
              onChange={(e) => setCaption(e.target.value)}
            />
          </HeaderWrapper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MainInfo;
